import React from "react";
import "./card.result.css";
import { upperCase } from "lodash";

function ResulftCardForPrintJAD({
  studentResultList,
  studentDetails,
  campusDetail,
  student_result_overall,
  icon,
  unitName,
  weekList,
  gradeData,
}) {
  const safeResultList = Array.isArray(studentResultList)
    ? studentResultList
    : [];
  const safeGradeData = Array.isArray(gradeData) ? gradeData : [];

  const getRange = (max_marks, min_marks) => {
    const percentage =
      ((Number(min_marks) || 0) / (Number(max_marks) || 1)) * 100;

    if (percentage <= 100 && percentage >= 90) {
      return "90% and above";
    } else if (percentage < 90 && percentage >= 80) {
      return "80% - 89.99%";
    } else if (percentage < 80 && percentage >= 70) {
      return "70% - 79.99%";
    } else if (percentage < 70 && percentage >= 60) {
      return "60% - 69.99%";
    } else if (percentage < 60 && percentage >= 50) {
      return "50% - 59.99%";
    } else if (percentage < 50 && percentage >= 0) {
      return "Below 50%";
    }

    return "--";
  };

  const getMonthName = (date) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date(date);

    return upperCase(`${monthNames[d.getMonth()]}, ${d.getFullYear()}`);
  };

  const getWeekNameById = (week_id) => {
    const week = Array.isArray(weekList)
      ? weekList.find((w) => w.id == week_id)
      : null;

    return week ? week.name : "Unknown Week";
  };

  const examTitle = () => {
    const exam = campusDetail?.exam;
    const examName = exam?.exam_type?.name || "";

    if (exam?.week_id != null && exam?.month != null) {
      return `${examName} (${getWeekNameById(exam.week_id)} OF ${getMonthName(
        exam.month,
      )})`;
    }

    if (exam?.week_id != null) {
      return `${examName} (${getWeekNameById(exam.week_id)})`;
    }

    if (exam?.month != null) {
      return `${examName} (${getMonthName(exam.month)})`;
    }

    return examName;
  };

  const formatMarks = (result) =>
    result?.status && result.status !== "Present"
      ? result.status
      : (result?.gain_marks ?? "--");

  const formatPercentage = (value) => {
    if (value === undefined || value === null || value === "") {
      return "--";
    }

    return `${value}%`;
  };

  const formatName = (value) => {
    if (!value) {
      return "";
    }

    return String(value)
      .toLowerCase()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const hasLsrwBreakup = (result) =>
    result?.subject?.is_partial == "1" ? true : false;

  const subjectRowCount = safeResultList.reduce(
    (total, result) => total + (hasLsrwBreakup(result) ? 2 : 1),
    0,
  );
  const isExtendedResult = subjectRowCount > 8;

  const renderSubjectRows = (result, index) => {
    if (hasLsrwBreakup(result)) {
      return (
        <React.Fragment key={result?.id || index}>
          <tr>
            <td className="jad-print-subject" rowSpan="2">
              {result?.subject?.name}
            </td>
            <td>Reading &amp; Writing</td>
            <td>{result?.full_marks_rw}</td>
            <td>{result?.gain_marks_rw}</td>
            <td>{formatPercentage(result?.percentage_rw)}</td>
            <td rowSpan="2">{result?.grade}</td>
          </tr>
          <tr>
            <td>Speaking &amp; Listening</td>
            <td>{result?.full_marks_sl}</td>
            <td>{result?.gain_marks_sl}</td>
            <td>{formatPercentage(result?.percentage_sl)}</td>
          </tr>
        </React.Fragment>
      );
    }

    return (
      <tr key={result?.id || index}>
        <td colSpan="2" className="jad-print-subject">
          {result?.subject?.name}
        </td>
        <td>{result?.full_marks}</td>
        <td>{formatMarks(result)}</td>
        <td>{formatPercentage(result?.percentage)}</td>
        <td>{result?.grade}</td>
      </tr>
    );
  };

  return (
    <div className="jad-print-page">
      <div
        className={`jad-print-card ${
          isExtendedResult ? "jad-print-card--extended" : ""
        }`}
      >
        <div className="jad-print-header">
          <div className="jad-print-logo">
            <img src={icon} alt="Jaada Schools" />
          </div>

          <div className="jad-print-title">
            <h1>{unitName || "Jaada Schools, Bahria Town Campus"}</h1>
            <h2>{examTitle()}</h2>
            <h3>Mark Sheet</h3>
          </div>

          <div className="jad-print-picture">
            <img
              src={
                studentDetails?.picture != null
                  ? studentDetails?.picture
                  : "/media/users/blank.png"
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
              }}
              alt="Student"
            />
          </div>
        </div>

        <table className="jad-print-info">
          <tbody>
            <tr>
              <th>Student's Name</th>
              <td>{formatName(studentDetails?.name)}</td>
              <th>Father's Name</th>
              <td>{formatName(studentDetails?.father_name)}</td>
            </tr>
            <tr>
              <th>Class</th>
              <td>
                {formatName(
                  campusDetail?.student_class?.name ||
                    safeResultList[0]?.student_class?.name,
                )}
              </td>
              <th>Section</th>
              <td>
                {formatName(
                  campusDetail?.global_section?.name ||
                    safeResultList[0]?.global_section?.name,
                )}
              </td>
            </tr>
            <tr>
              <th>Admission ID</th>
              <td>{studentDetails?.admission_id}</td>
              <th>Session</th>
              <td>{campusDetail?.exam?.session?.year}</td>
            </tr>
          </tbody>
        </table>

        <table className="jad-print-marks">
          <colgroup>
            <col className="jad-print-subject-col" />
            <col className="jad-print-component-col" />
            <col className="jad-print-total-col" />
            <col className="jad-print-obtain-col" />
            <col className="jad-print-percent-col" />
            <col className="jad-print-grade-col" />
          </colgroup>
          <thead>
            <tr>
              <th colSpan="2">Subjects</th>
              <th>Total Marks</th>
              <th>Obtained Marks</th>
              <th>%</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {safeResultList.map(renderSubjectRows)}
            <tr className="jad-print-overall">
              <td colSpan="2">Overall Result</td>
              <td>{student_result_overall?.total_full_marks}</td>
              <td>{student_result_overall?.total_gain_marks}</td>
              <td>{student_result_overall?.percentage}</td>
              <td>{student_result_overall?.grade}</td>
            </tr>
          </tbody>
        </table>

        {!isExtendedResult && (
          <table className="jad-print-range">
            <thead>
              <tr>
                <th className="jad-text-end">Percentage Range</th>
                <th className="jad-text-center jad-border-left">Grade</th>
                <th className="jad-text-start">Achievement Level</th>
              </tr>
            </thead>
            <tbody>
              {safeGradeData.map((level, index) => (
                <tr key={index}>
                  <td className="jad-text-end font-italic">
                    {getRange(level.max_marks, level.min_marks)}
                  </td>
                  <td className="jad-text-center jad-border-left">
                    {level.grade}
                  </td>
                  <td className="jad-text-start">{level.level}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <table className="jad-print-grade-detail">
          <colgroup>
            <col className="jad-grade-code-col" />
            <col className="jad-grade-level-col" />
            <col className="jad-grade-description-col" />
          </colgroup>
          <thead>
            <tr>
              <th className="jad-text-center">Grade</th>
              <th className="jad-text-center jad-border-left">Level</th>
              <th className="jad-text-start">Description</th>
            </tr>
          </thead>
          <tbody>
            {safeGradeData.map((level, index) => (
              <tr key={index}>
                <td className="jad-text-center">{level.grade}</td>
                <td className="jad-text-center jad-border-left">
                  {level.level}
                </td>
                <td className="jad-text-start">{level.description}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="jad-print-signatures">
          <div>
            <strong>Teacher's Signature</strong>
            <span></span>
          </div>
          <div>
            <strong>Principal's Signature</strong>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResulftCardForPrintJAD;
